import { makeStyles } from "@material-ui/styles";
import React from "react";
import clsx from "clsx";
import PlannerMinuteBox from "./PlannerMinuteBox";
import { IPlannerMinute, ITripPlanner, Iuser, ServicedBy } from "../types/plannerTypes";
import { prepareTimelineContent } from "./plannerHelpers";
import { IPlannerState } from "../../../store/modules/plannerSlice";
import PlannerTrip from "./PlannerTrip";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import api from '../../../store/api';



interface TimelineMinutesProps {
  selectedDay: string;
  plannerStore: IPlannerState;
  tripPlanner: ITripPlanner;
  setErrorMessage: any;
  setConflictDialogData: any;
  timelineContent: IPlannerMinute[];
  setTimelineContent: any;
  applyTimelineChanges: any;
  showAdHocRequestModal: any;
  blockLabel: string | null;
  userid: string | null;
  roles: any;
  selectedLocationId: string;
}

const timelineHeight = 90;
const hourLabelHeight = 30;

const useStyles = makeStyles((theme) => ({
  minutes: {
    flexGrow: 1,
    flexDirection: "column",
    justifyContent: "center",
    display: "flex",
    borderLeft: "1px solid transparent",

    "&:last-child": {
      flexGrow: "0",
    },
  },
  hourBorder: {
    borderLeft: "2px #2172b7 solid",
  },
  cusHourBorder: {
    borderLeft: "2px #947AAC solid",
  },
  minutesBorder: {
    borderLeft: "1px #0061b0 solid",
  },
  cusMinutesBorder: {
    borderLeft: "1px #6b5283 solid",
  },
  trip: {
    height: 30,
    background: "#6698cc",
    zIndex: 40,
    marginLeft: "-1px",
  },
  timeline: {
    display: "flex",
    height: timelineHeight - hourLabelHeight,
    width: "100%",
    flexDirection: "row",
    zIndex: 1050,
  },
}));

const TimelineMinutes: React.FC<TimelineMinutesProps> = (props) => {
  const {
    selectedDay,
    tripPlanner,
    plannerStore,
    setErrorMessage,
    setConflictDialogData,
    timelineContent,
    setTimelineContent,
    blockLabel,
    applyTimelineChanges,
    showAdHocRequestModal,
    userid,
    roles,
    selectedLocationId,
  } = props;
  // useTraceUpdate(props);
  const classes = useStyles();
    const { plannerDraggingTripStore } = useSelector((state: RootState) => state);

  React.useEffect(() => {
    const timelineVisualState = plannerStore.visualState.filter((v: any) => v.tripPlannerId == tripPlanner.tripPlannerId);
    setTimelineContent(prepareTimelineContent(tripPlanner, selectedDay, timelineVisualState, plannerStore.localState, plannerDraggingTripStore.draggingTripId || ""));
  }, [tripPlanner, selectedDay, plannerStore, plannerDraggingTripStore]);

  const styleQuarter =Number(tripPlanner.servicedBy)==ServicedBy.SMA ?  clsx(classes.minutes, classes.minutesBorder) :  clsx(classes.minutes, classes.cusMinutesBorder);
  const styleHour =Number(tripPlanner.servicedBy)==ServicedBy.SMA ? clsx(classes.minutes, classes.hourBorder) : clsx(classes.minutes, classes.cusHourBorder);

  const getMinuteStyle = (date: Date): string => {
    const mins = date.getMinutes();
    if (mins % 60 === 0) return styleHour;
    if (mins % 15 === 0) return styleQuarter;
    return classes.minutes;
  };

  const chooseNMinuteBox = (plannerMinute: IPlannerMinute, index: number) => {
    if (!plannerMinute.isDnD)
      return (
        <div key={index} className={getMinuteStyle(plannerMinute.date)}>
          {plannerMinute.trip && (
            <PlannerTrip
              plannerMinute={plannerMinute}
              isPassed={plannerMinute.isPassed}
              showAdHocRequestModal={showAdHocRequestModal}
              blockLabel={blockLabel}
              noOfStretchers={tripPlanner.noOfStretchers}
              noOfPatientSeats={tripPlanner.noOfPatientSeats}
              tripplaner={tripPlanner}
              setConflictDialogData={setConflictDialogData}       
              selectedLocationId={selectedLocationId}   
            />
          )}
        </div>
      );
    // const key = plannerMinute.trip ? `${index.toString()}${plannerMinute.trip.virtualTripId.substring(0, 4)}` : index.toString();
    const key = plannerMinute.date?.getTime() ?? "";
    return (
      <PlannerMinuteBox
        key={key}
        plannerMinute={plannerMinute}
        getMinuteStyle={getMinuteStyle}
        applyTimelineChanges={applyTimelineChanges}
        isPassed={plannerMinute.isPassed}
        blockLabel={blockLabel}
        showAdHocRequestModal={showAdHocRequestModal}
        isMutliloadAllowed={tripPlanner.isMutliloadAllowed}
        noOfStretchers={tripPlanner.noOfStretchers || 0}
        noOfPatientSeats={tripPlanner.noOfPatientSeats || 0}
        plannerAcuity={tripPlanner.maxPatientAcuity}
        setConflictDialogData={setConflictDialogData}
        userid={userid}
        tripplaner ={tripPlanner}
        roles={roles}
        selectedLocationId={selectedLocationId}   
      />
    );
  };

  return <div className={classes.timeline}>{timelineContent.map((plannerMinute, index) =>
     chooseNMinuteBox(plannerMinute, index))}</div>;
};
export default React.memo(TimelineMinutes);
